module.exports = __webpack_public_path__ + "static/media/portfolio9.a7493e1e.png";